<template>
<modal title="Add to Standard">
  <div class="columns">
    <div class="column">
      <select-input
        v-model="standard.standard_id"
        :items="availableStandards"
        label-key="name"
        value-key="id">
        Standard
      </select-input>
    </div>
  </div>  
  <div class="columns">
    <div class="column">
      <select-input
        :disabled="!activeStandard"
        :items="availableSections"
        v-model="standard.section_id"
        label-key="title"
        value-key="id">
        Section
      </select-input>
    </div>
  </div>  
  <div class="columns">
    <div class="column">
      <p class="has-text-danger" v-if="assessorRequiresSecureSetting">
        This checkpoints assessor requires a secure setting for assessment. 
        After you have assigned the checkpoint to this standard you will be required
        to set a value for it's secure setting before it will be used in assessments.
      </p>
    </div>
  </div>  
  
  <template #footer>
    <div class="buttons">
      <action-button :working="working" @click="addStandardToCheckpoint">Save</action-button>
    </div>
  </template>
</modal>  
</template>
<script>
import { mapGetters } from 'vuex'
import { differenceBy, find } from 'lodash'

export default {
  
  props: {
    checkpoint: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    working: false,
    standards: [],
    standard: {
      standard_id: '',
      section_id: ''
    }
  }),

  beforeCreate() {
    this.$store.dispatch('standard/loadStandardsList')
  },

  methods: {
    addStandardToCheckpoint() {
      this.working = true
      this.$store.dispatch('checkpoint/addStandard', {
        ...this.standard,
        checkpointId: this.checkpoint.id
      }).then(() => {
        this.$toast.success('Standard added')
        this.$close(true)
        this.working = false
      }).catch(error => {
        this.working = false
      })
    }
  },

  computed: {
    ...mapGetters('standard', [
      'standardsList'
    ]),
    checkpointStandards() {
      return this.checkpoint.sections.map(section => section.standard)
    },
    availableStandards() {
      return differenceBy(this.standardsList, this.checkpointStandards, 'id')
    },
    activeStandard() {
      return find(this.standardsList, standard => standard.id === this.standard.standard_id)
    },
    availableSections() {
      return this.activeStandard ? this.activeStandard.sections : []
    },
    assessorRequiresSecureSetting() {
      return this.checkpoint.assessor && this.checkpoint.assessor.type && this.checkpoint.assessor.type.standard_fed
    }
  }

}
</script>